import { render, staticRenderFns } from "./EstimatesTabNew.vue?vue&type=template&id=1d9b02ce"
import script from "./EstimatesTabNew.vue?vue&type=script&lang=ts"
export * from "./EstimatesTabNew.vue?vue&type=script&lang=ts"
import style0 from "./EstimatesTabNew.vue?vue&type=style&index=0&id=1d9b02ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VDialog,VProgressLinear,VRow})
